/// <reference path='../../interfaces/interfaces.d.ts' />

'use strict';
// FIXME: Review after the merge
class InlineEditFileUploadDirective {

    public restrict = 'E';
    public scope;
    public template;
    public currentValue;

    public doc;

    constructor(private $timeout: any) {
        this.restrict = 'E';
        this.scope = {
            fileType: '=?',
            fileName: '=?',
            fileLink: '=',
            saveFunc: '&?',
            deleteFunc: '&?',
            currentValue: '@?',
            label: '@?',
            canEdit: '=?'
        };

        this.template = `
            <div class="col-12 form-group no-bot-pad m-b-0 p-l-0 m-t-10 m-b-10">  
                <div class="row">
                    <div class="col-md-8 col-12 p-l-0">
                        <md-input-container class="m--0 m-l-15 flex-center d-inline-flex w-100">
                            <label class="md-reset">{{label}}</label> 
                            <input class="text-center" type="text" readonly ng-model="fileName" placeholder='Select a file' ng-disabled="canEdit == false">
                        </md-input-container>
                        <input class="form-input ile-dir-file dir-file-span" type="file" data-file-model="fileLink" ng-disabled="canEdit == false">
                    </div>              
                    <div class="col-md-4 col-12 p-l-0 flex-center">
                        <md-button class='md-icon md-warn cus-md-icon-button m-0 w-unset' ng-click='deleteFile()' ng-show="fileLink && deleteFunc" ng-disabled="canEdit == false">
                            <md-icon class='p-0' md-font-library='material-icons'>
                                delete_forever                    
                            </md-icon>
                            
                        </md-button>
                        <md-button class='md-icon md-primary cus-md-icon-button m-0 w-unset' href="{{fileLink}}" target='_blank' ng-show="fileLink">
                            <md-icon class='p-0' md-font-library='material-icons'>
                                cloud_download 
                            </md-icon>
                        </md-button>
                    </div>
                </div>
            </div>
        `;
    }

    public link($scope: any, $element: any, attrs: any): any {

        $element.on('change', function (): any {
            $scope.editing = false;
            var newValue: any = $scope.fileLink;
            // $element.removeClass('active');
            var saveObj: any = {
                old: $scope.currentValue,
                new: newValue,
                model: attrs.fileLink,
                fileType: attrs.fileType
            };
            // there is an issue with parsing the model name through the file-name in the jade.
            // this pulls the name from the upload object before it has been saved and saves it in the file name model
            // this should probably be given its own variable in the controller so it can be set on load
            if (saveObj.new !== saveObj.old) {
                $scope.fileName = saveObj.new.name;
            }
            $scope.saveFunc({args: saveObj});
        });


        $scope.edit = function (): any {

            // $scope.editing = true;
            // /*$scope.fileLink || undefined*/
            // $element.addClass('active');
            // $element.addClass('');
            $scope.currentValue = (($scope.fileLink === undefined) ? 'newFile' : $scope.fileLink);
        };

        $scope.deleteFile = function (): any {
            $scope.deleteFunc();
            // $element.removeClass('active');
        };

        $scope.undo = function (): any {
            // $element.removeClass('active');
            // $scope.fileLink = undefined;
        };
    }

    public parseFileName(input: any): string {
        if (!_.isEmpty(input)) {
            return decodeURI(input.substring(input.lastIndexOf('/') + 1));
        }
    }

    public static DirectiveFn($timeout: any): InlineEditFileUploadDirective {
        return new InlineEditFileUploadDirective($timeout);
    }
}

InlineEditFileUploadDirective.DirectiveFn.$inject = ['$timeout'];

angular.module('beneple.global').directive('inlineEditFileUpload', InlineEditFileUploadDirective.DirectiveFn);



// WEBPACK FOOTER //
// ./frontend/scripts/global/directives/inline_edit_file_upload.directive.ts